import React from 'react'
import ToggleButton from '@mui/material/ToggleButton'
import { SegmentedToggleButtonContent } from './mui5-segmented-toggle-button-content'

export function SegmentedToggleButton({
  children,
  groupValue,
  value,
  showCheck = true,
  ...props
}) {
  const isSelected = groupValue === value

  return (
    <ToggleButton value={value} {...props}>
      <SegmentedToggleButtonContent
        isSelected={isSelected}
        showCheck={showCheck}
      >
        {children}
      </SegmentedToggleButtonContent>
    </ToggleButton>
  )
}

export { SegmentedToggleButton as default }
